// extracted by mini-css-extract-plugin
export default {"externalComponentsContainer":"externalComponents_externalComponentsContainer__-sWb-","editNarrativeContainer":"externalComponents_editNarrativeContainer__nnfdw"};